import React from 'react';

import { useApp } from '../../../store/AppContext';

const CLASSES = {
  left: 'absolute left-[0] top-[0] bottom-[0] w-[7px] [cursor:ew-resize]',
  right: 'absolute right-[0] top-[0] bottom-[0] w-[7px] [cursor:ew-resize]',
};
const ROUNDED = {
  left: ' [border-top-left-radius:6px] [border-bottom-left-radius:6px]',
  right: ' [border-top-right-radius:6px] [border-bottom-right-radius:6px]',
};

/* Poignée gauche ou droite d'une barre : démarre le redimensionnement de l'affectation. */
export default function ResizeHandle({ edge, affId, match, dayIdx, rounded }) {
  const { days, setTimelineResize } = useApp();
  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
        setTimelineResize({ affId, ...match, edge, currentIso: days[dayIdx].iso });
      }}
      className={CLASSES[edge] + (rounded ? ROUNDED[edge] : '')}
    />
  );
}
